// Unpacks Thermals/Day into the per-frame fields the HuntWind thermals model takes. Kept free of React and the
// map so it can be tested.

const bytesOf = s => {
  const raw = atob(s)
  const bytes = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i)
  return bytes
}

// A grid of little-endian int16 in units of `scale` m/s, as m/s.
export function decodeGrid(s, scale = 0.01) {
  const bytes = bytesOf(s || '')
  const view = new DataView(bytes.buffer)
  const out = new Float32Array(bytes.length >> 1)
  for (let i = 0; i < out.length; i++) out[i] = view.getInt16(i * 2, true) * scale
  return out
}

// One signed byte per cell: 1 upslope, -1 downslope, 0 still.
export const decodeRegime = s => new Int8Array(bytesOf(s || '').buffer)

const decoded = new WeakMap()

// Frame `i` of a day as a field the model takes: the day's shared grid with that frame's grids decoded.
// cu, cv are the combined wind (the forecast's wind at scent height plus the slope wind). Decoded once per frame.
export function frameField(day, i) {
  const frame = day && day.frames && day.frames[i]
  if (!frame) return null
  let cache = decoded.get(day)
  if (!cache) decoded.set(day, cache = [])
  if (!cache[i]) {
    const scale = (day.encoding && day.encoding.scaleMs) || 0.01
    const { frames, encoding, surfaces, ...shared } = day
    cache[i] = {
      ...shared,
      ...frame,
      u: decodeGrid(frame.u, scale),
      v: decodeGrid(frame.v, scale),
      cu: decodeGrid(frame.cu, scale),
      cv: decodeGrid(frame.cv, scale),
      regime: decodeRegime(frame.regime)
    }
  }
  return cache[i]
}

// Bilinear sample of a cols x rows grid at fractional cell coordinates (x right, y down from the north-west cell
// centre), clamped to the grid.
export function sample(grid, cols, rows, x, y) {
  const cx = Math.max(0, Math.min(cols - 1, x)), cy = Math.max(0, Math.min(rows - 1, y))
  const x0 = Math.floor(cx), y0 = Math.floor(cy)
  const x1 = Math.min(cols - 1, x0 + 1), y1 = Math.min(rows - 1, y0 + 1)
  const tx = cx - x0, ty = cy - y0
  const a = grid[y0 * cols + x0], b = grid[y0 * cols + x1], c = grid[y1 * cols + x0], d = grid[y1 * cols + x1]
  return (a * (1 - tx) + b * tx) * (1 - ty) + (c * (1 - tx) + d * tx) * ty
}
